import { useTranslation } from "react-i18next";
import styles from "./FreeListing.module.scss";
import CustomButton from "../../components/ui/CustomButton/CustomButton";

import easyIntegration from "../../assets/images/free-listing/easy-integration.svg";
import hassleFreePayments from "../../assets/images/free-listing/hassle-free-payments.svg";
import increaseBookings from "../../assets/images/free-listing/increase-bookings.svg";
import noUpfrontFees from "../../assets/images/free-listing/no-upfront-fees.svg";
import performanceInsights from "../../assets/images/free-listing/performance-insights.svg";

import createYourFreeListing from "../../assets/images/free-listing/create-your-free-listing.svg";
import setYourScheduleAndPricing from "../../assets/images/free-listing/set-your-schedule-pricing.svg";
import getMoreClientsAndGrow from "../../assets/images/free-listing/get-more-clients-grow.svg";
import getPaidWithEase from "../../assets/images/free-listing/get-paid-with-ease.svg";

import starsIcon from "../../assets/images/icons/stars.svg";
import testimonial01 from "../../assets/images/free-listing/testimonial-01.jpg";
import testimonial02 from "../../assets/images/free-listing/testimonial-02.jpeg";

import startListing from "../../assets/images/free-listing/start-listing.png";

import readyImage from "../../assets/images/free-listing/ready.png";
import FAQ from "../../components/FAQ/FAQ";
import FormItemInput from "../../components/ui/FormItemInput/FormItemInput";
import { Form, FormInstance } from "antd";
import React, { useRef, useState } from "react";
import FormItemSelect from "../../components/ui/FormItemSelect/FormItemSelect";
import FormItemCheckbox from "../../components/ui/FormItemCheckbox/FormItemCheckbox";
import PhoneNumberInput from "../../components/ui/PhoneNumberInput/PhoneNumberInput";
import AddressInput from "../../components/ui/AddressInput/AddressInput";
import axios from "axios";
import { environment } from "../../environment";
import useAppDispatch from "../../hooks/useAppDispatch";
import { openErrorMessage, openSuccessMessage } from "../../store/message/messageSlice";
import { Helmet } from "react-helmet";
import { handleError } from "../../helper/errorHandler";

const FreeListing = () => {
  const formRef = useRef<FormInstance>(null);
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();

  const [selectedCode, setSelectedCode] = useState("+30");
  const [phoneNumber, setPhoneNumber] = useState<{ value: string; isValid: boolean }>({
    value: "",
    isValid: true,
  });
  const [formatedAddress, setFormatedAddress] = useState<{ value: string; isValid: boolean }>({
    value: "",
    isValid: true,
  });

  const businessTypes = [
    {
      id: "fitness",
      label: t("Fitness"),
    },
    {
      id: "pilates",
      label: t("PilatesStudio"),
    },
    {
      id: "yoga",
      label: t("YogaStudio"),
    },
    {
      id: "gym",
      label: t("Gym"),
    },
    {
      id: "crossfit",
      label: t("Crossfit"),
    },
    {
      id: "calisthenics",
      label: t("Calisthenics"),
    },
  ];

  const faqs: { question: string; answer: string | string[] }[] = [
    {
      question: t("HowDoesClubPassHelpMyGymGrow"),
      answer: t("ClubPassIncreasesYourGymVisibility"),
    },
    {
      question: t("CanISetCustomLimitsOnClubPassVisitors"),
      answer: t("YesYouCanSetDailyWeeklyOrMonthlyVisitLimits"),
    },
    {
      question: t("HowDoITrackMyGymPerformanceOnClubPass"),
      answer: t("YouCanMonitorYourRevenueVisitorStats"),
    },
    {
      question: t("DoIHaveControlOverPricingAndPromotions"),
      answer: t("YesYouCanCustomizePromotionsForClubPassMembers"),
    },
    {
      question: t("WhatMarketingBenefitsDoIGetWithClubPass"),
      answer: t("ClubPassActivelyPromotesYourGymThroughTargetedAds"),
    },
    {
      question: t("WhatExclusivePerksDoClubPassPartnerGymsReceive"),
      answer: [
        t("OffOnGymEquipmentExclusiveForTYPSubscribers"),
        t("BusinessNewsletterAccessPremiumGuidesToHelp"),
        t("FreeClubPassMembershipForYearForEarlyAdopters"),
      ],
    },
    {
      question: t("HowCanIFeatureMyGymInClubPassNewslettersAndCampaigns"),
      answer: t("YouCanApplyForPromotionalOpportunitiesViaYourClubPassDashboard"),
    },
    {
      question: t("CanIOfferDifferentTypesOfMembershipsThroughClubPass"),
      answer: t("YesYouCanProvideDayPassesWeeklyPlansGroupClasses"),
    },
    {
      question: t("HowDoIOptimizeMyClubPassGymProfileForBetterReach"),
      answer: t("EnsureYourProfileIncludesHighQualityImagesUpdatedClassSchedules"),
    },
    {
      question: t("CanIGetAdditionalRevenueStreamsFromClubPass"),
      answer: t("YesBesidesRegularBookingsYouCanEarnFromClubPassExclusive"),
    },
    {
      question: t("HowDoIGetMoreSignupsFromClubPass"),
      answer: [
        t("OfferSpecialDiscountsForFirstTimeVisitors"),
        t("ParticipateInClubPassMarketingCampaigns"),
        t("KeepYourProfileIUpdatedWithFreshOffers"),
        t("OptimizeYourClassScheduleToMatchPeakBookingTimes"),
      ],
    },
  ];

  const redirectToCalendly = () => {
    window.open("https://calendly.com/clubpass/30min", "_blank");
  };

  const onFinishFailed = async () => {
    if (!phoneNumber.value) {
      setPhoneNumber({
        value: phoneNumber.value,
        isValid: false,
      });
    }
    if (!formatedAddress.value) {
      setFormatedAddress({
        value: formatedAddress.value,
        isValid: false,
      });
    }
  };

  const onFinish = async (values: any) => {
    if (!phoneNumber.value || !formatedAddress.value) {
      if (!phoneNumber.value) {
        setPhoneNumber({
          value: phoneNumber.value,
          isValid: false,
        });
      }
      if (!formatedAddress.value) {
        setFormatedAddress({
          value: formatedAddress.value,
          isValid: false,
        });
      }
      return;
    }

    const availableServices = [
      { label: "Open Gym Access", value: values.openGymAccess },
      { label: "Personal Training", value: values.personalTraining },
      { label: "Group Fitness Classes", value: values.groupFitnessClasses },
      { label: "Swimming Pool Access", value: values.swimmingPoolAccess },
      { label: "Running Club", value: values.runningClub },
      { label: "Kids Fitness Programs", value: values.kidsFitnessPrograms },
    ];

    const model = {
      businessName: values.businessName,
      name: values.name,
      email: values.email,
      phoneNumber: `${selectedCode}${phoneNumber.value}`,
      businessType: businessTypes.find((el) => el.id === values.businessType)?.label || "-",
      location: formatedAddress.value,
      availableServices: availableServices.filter((el) => el.value).map((el) => el.label),
    };

    try {
      const response = await axios.post(
        `${environment.authPath}/api/v2/website/club-pass/send-listing-business-offer`,
        model
      );
      if (response.data) {
        formRef.current?.resetFields();
        setFormatedAddress({ value: "", isValid: true });
        setPhoneNumber({ value: "", isValid: true });
        dispatch(openSuccessMessage(t("MailSentSuccessfully")));
      } else {
        dispatch(openErrorMessage(t("SOMETHING_WENT_WRONG")));
      }
    } catch (e) {
      handleError(e, dispatch, t);
    }
  };

  const renderContactMail = () => {
    const email = "info@clubpass.global";
    if (i18n.language === "en") {
      return (
        <>
          {t("Our")} <a href={`mailto:${email}`}>email</a>.
        </>
      );
    } else {
      return (
        <>
          <a href={`mailto:${email}`}>email</a> {t("Our")}.
        </>
      );
    }
  };

  return (
    <>
      <Helmet>
        <title>{t("ListYourGymOrSalonForFree")}</title>
        <meta
          name="description"
          content={t("ReachNewCustomersByListingYourGymOrSalonForFreeOnClubPass")}
        />
      </Helmet>
      <div className={styles.page}>
        {/* Hero section */}
        <section className={styles.hero}>
          <div className={`${styles.heroWrapper} container`}>
            <h1>{t("GetMoreCustomersListYourBusinessForFreeOnClubPass")}</h1>
            <p>{t("JoinThousandsOfFitnessStudiosSalons")}</p>
            <div className={styles.btnWrapper}>
              <CustomButton
                functionOnClick={redirectToCalendly}
                text={t("GetStartedForFree")}
                type={"button"}
                typeStyle={"fill"}
                style={{
                  display: "inline-flex",
                }}
              />
            </div>
          </div>
        </section>

        {/* Why love section */}
        <section className={`${styles.why} container`}>
          <h2 className={styles.title}>{t("WhyBusinessesLoveClubPass")}</h2>
          <p className={styles.subtitle}>{t("ExpandYourReachAndAttract")}</p>

          <div className={styles.wrapper}>
            <div className={styles.item}>
              <img src={increaseBookings} alt={t("IncreaseBookings")} />
              <h4>{t("IncreaseBookings")}</h4>
              <p>{t("TapIntoALargeCustomerBaseReadyToBook")}</p>
            </div>

            <div className={styles.item}>
              <img src={noUpfrontFees} alt={t("NoUpfrontFees")} />
              <h4>{t("NoUpfrontFees")}</h4>
              <p>{t("ListYourBusinessForFreePayOnlyWhenYouGetBookings")}</p>
            </div>

            <div className={styles.item}>
              <img src={hassleFreePayments} alt={t("HassleFreePayments")} />
              <h4>{t("HassleFreePayments")}</h4>
              <p>{t("SecureTransactionsWithSeamlessPayoutProcessing")}</p>
            </div>

            <div className={styles.item}>
              <img src={easyIntegration} alt={t("EasyIntegration")} />
              <h4>{t("EasyIntegration")}</h4>
              <p>{t("SyncYourCalendarAndManageAvailabilityInRealTime")}</p>
            </div>

            <div className={styles.item}>
              <img src={performanceInsights} alt={t("PerformanceInsights")} />
              <h4>{t("PerformanceInsights")}</h4>
              <p>{t("TrackCustomerVisitsAndOptimizeYourBusiness")}</p>
            </div>
          </div>
        </section>

        {/* How works section */}
        <section className={`${styles.how}`}>
          <div className="container">
            <div className={styles.box}>
              <h2 className={styles.title}>{t("HowClubPassWorksForYourBusiness")}</h2>
              <ul className={styles.list}>
                <li className={styles.item}>
                  <img src={createYourFreeListing} alt={t("CreateYourFreeListing")} />
                  <div>
                    <h3>
                      <span>{t("Step")} 1:</span> {t("CreateYourFreeListing")}
                    </h3>
                    <p>{t("SignUpAndAddYourBusinessDetails")}</p>
                  </div>
                </li>

                <li className={styles.item}>
                  <img src={setYourScheduleAndPricing} alt={t("SetYourSchedulePricing")} />
                  <div>
                    <h3>
                      <span>{t("Step")} 2:</span> {t("SetYourSchedulePricing")}
                    </h3>
                    <p>{t("ControlAvailabilityAndPricingForBookings")}</p>
                  </div>
                </li>

                <li className={styles.item}>
                  <img src={getMoreClientsAndGrow} alt={t("GetMoreClientsGrow")} />
                  <div>
                    <h3>
                      <span>{t("Step")} 3:</span> {t("GetMoreClientsGrow")}
                    </h3>
                    <p>{t("CustomersDiscoverAndBookYourServicesInstantly")}</p>
                  </div>
                </li>

                <li className={styles.item}>
                  <img src={getPaidWithEase} alt={t("GetPaidWithEase")} />
                  <div>
                    <h3>
                      <span>{t("Step")} 4:</span> {t("GetPaidWithEase")}
                    </h3>
                    <p>{t("ReceivePaymentsSecurelyWithoutAnyExtraHassle")}</p>
                  </div>
                </li>
              </ul>
              <div className={"flex-just-center"}>
                <CustomButton
                  functionOnClick={redirectToCalendly}
                  text={t("ListYourBusinessNow")}
                  type={"button"}
                  typeStyle={"fill"}
                  style={{
                    width: "unset",
                    display: "inline-flex",
                  }}
                />
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials section */}
        <section className={`${styles.testimonials} container`}>
          <h3 className={styles.title}>{t("WhatOurPartnersSay")}</h3>
          <p className={styles.subtitle}>
            {t("BusinessesUsingClubPassHaveSeenASignificantIncreaseInBookings")}
          </p>
          <div className={styles.wrapper}>
            <div className={styles.item}>
              <img className={styles.profile} src={testimonial01} alt={"testimonial-01"} />
              <div>
                <img src={starsIcon} alt={"Stars"} />
                <p>{t("ClubPassHasCompletelyTransformedHowWeManageOurBookings")}</p>
                <p className={styles.name}>
                  {"MALCOLM M"} <span>{"Founder of MK Pilates"}</span>
                </p>
              </div>
            </div>

            <div className={styles.item}>
              <img className={styles.profile} src={testimonial02} alt={"testimonial-02"} />
              <div>
                <img src={starsIcon} alt={"Stars"} />
                <p>{t("SinceJoiningClubPassOurStudioHasGainedSteadyStream")}</p>
                <p className={styles.name}>
                  {"Niki Tzortzi"} <span>{"Owner of Pilates Fitness Yoga"}</span>
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Start listing section */}
        <section className={styles.start}>
          <img src={startListing} alt={"Start listing"} />
          <div className={styles.box}>
            <h2 className={styles.title}>{t("DeclarationOfInterestToParticipate")}</h2>
            <p className={styles.subtitle}>
              {t("SignUpInMinutesAndStartReceivingBookingsEffortlessly")}
            </p>

            <Form
              className={styles.form}
              ref={formRef}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              name="contact-information"
              layout={"vertical"}
              initialValues={{ phoneNumber: "" }}
            >
              <FormItemInput
                name={"businessName"}
                label={t("BusinessName")}
                rules={{ required: true }}
                isSettingInput={true}
                placeholder={t("EnterYourBusinessName")}
              />

              <FormItemInput
                name={"name"}
                label={t("YourName")}
                rules={{ required: true }}
                isSettingInput={true}
                placeholder={t("EnterYourName")}
              />

              <FormItemInput
                name={"email"}
                label={t("Email")}
                rules={{ required: true }}
                isSettingInput={true}
                placeholder={"you@company.com"}
              />

              <PhoneNumberInput
                selectedCode={selectedCode}
                setSelectedCode={setSelectedCode}
                phoneNumber={phoneNumber}
                setPhoneNumber={setPhoneNumber}
              />

              <FormItemSelect
                name={"businessType"}
                label={t("BusinessType")}
                rules={{ required: true }}
                items={businessTypes}
                isSettingInput={true}
                showSearch={true}
                placeholder={t("Select") + "..."}
              />

              <AddressInput
                formatedAddress={formatedAddress}
                setFormatedAddress={setFormatedAddress}
              />

              <div className={styles.checkBoxexGroup}>
                <FormItemCheckbox
                  name={"openGymAccess"}
                  label={t("OpenGymAccess")}
                  rules={{ required: false }}
                  isSettingInput={true}
                />

                <FormItemCheckbox
                  name={"personalTraining"}
                  label={t("PersonalTraining")}
                  rules={{ required: false }}
                  isSettingInput={true}
                />

                <FormItemCheckbox
                  name={"groupFitnessClasses"}
                  label={t("GroupFitnessClasses")}
                  rules={{ required: false }}
                  isSettingInput={true}
                />

                <FormItemCheckbox
                  name={"swimmingPoolAccess"}
                  label={t("SwimmingPoolAccess")}
                  rules={{ required: false }}
                  isSettingInput={true}
                />

                <FormItemCheckbox
                  name={"runningClub"}
                  label={t("RunningClub")}
                  rules={{ required: false }}
                  isSettingInput={true}
                />

                <FormItemCheckbox
                  name={"kidsFitnessPrograms"}
                  label={t("KidsFitnessPrograms")}
                  rules={{ required: false }}
                  isSettingInput={true}
                />
              </div>

              <CustomButton text={t("ListMyBusinessNow")} type={"submit"} typeStyle={"fill"} />
            </Form>
          </div>
        </section>

        {/* FAQ section */}
        <FAQ faqs={faqs} backgroundColor={"#F8FAFC"} />

        {/* Ready to get started section */}
        <section className={`${styles.ready} container`}>
          <div className={styles.box}>
            <img src={readyImage} alt={"Ready to get started"} />
            <h2 className={styles.title}>{t("ReadyToGetStartedItsFree")}</h2>
            <p className={styles.subtitle}>
              {t("HaveQuestionsReachOutToOurTeam")} {renderContactMail()}
            </p>
            <CustomButton
              functionOnClick={redirectToCalendly}
              text={t("ListYourBusinessNow")}
              type={"button"}
              typeStyle={"fill"}
              style={{
                display: "inline-flex",
                width: "unset",
              }}
            />
          </div>
        </section>
      </div>
    </>
  );
};

export default FreeListing;
